import type { InquiryTraceEntriesParams } from './inquiry-findings.types';

export const getTraceEntriesCacheKey = (queryArgs: InquiryTraceEntriesParams): string =>
  JSON.stringify(normalizeForCacheKey(queryArgs, new Set(['sort'])));

const normalizeForCacheKey = (value: unknown, excludedKeys: Set<string>): unknown => {
  if (Array.isArray(value)) {
    if (value.length === 0) return undefined;
    return [...(value as string[])].sort((a, b) => a.localeCompare(b));
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => [k, excludedKeys.has(k) ? v : normalizeForCacheKey(v, excludedKeys)]),
    );
  }
  return value;
};
